var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeatMapIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12-1h2a1 1 0 0 1 1 1v7h-3zm-1 0H5v3h6zM4 1H2a1 1 0 0 0-1 1v2h3zM1 5v4h3V5zm0 5v4a1 1 0 0 0 1 1h4v-5zm6 5h7a1 1 0 0 0 1-1v-4H7zm4-6H5V5h6z",
  clipRule: "evenodd"
})));
export default SvgHeatMapIcon;